import { useAuthContext } from "BEDROCK/auth/auth-provider";
import { LandingPageGuest } from "./landing-page-guest";
import { LandingPageUser } from "./landing-page-user";
import * as amplitude from "@amplitude/analytics-browser";
import { useAnalyticsTracker } from "analytics-tracker";

interface LandingProps {}

export const LandingPage = (props: LandingProps) => {
  const { isUserAuthenticated } = useAuthContext();
  const { trackEvent } = useAnalyticsTracker();

  trackEvent("Landing page viewed");

  return isUserAuthenticated ? <LandingPageUser /> : <LandingPageUser />;
};
